import {useEffect} from 'react'
import ReactPaginate from 'react-paginate'
import {useNavigate} from 'react-router-dom'
import {KTCard, KTSVG} from '../../../../../../_metronic/helpers'
import {timeDateFormatter} from '../../../../../../_metronic/helpers/datetime-formatter'
import {generateStatusBadge} from '../../../../../../_metronic/helpers/generate-status-badge'
import {generateCurrencyFormat} from '../../../../../helpers/generate-currency-format'
import {FormAction} from '../../../../../interfaces/form-action-interfaces'
import {useAuth} from '../../../../auth'
import {LoadingComponent} from '../../../crm/properties-management/components/loading.component'
import {
  useDonationAffiliateStore,
  useDonationAffiliateFormStore,
} from '../states/program-affiliate.state'
import DonationAffiliateModalComponent from './donation-affiliate-modal.component'

const DonationListAffiliatorComponent = () => {
  const {
    activeNavIndex,
    navList,
    setActiveNavIndex,
    donationAffiliateLoading,
    donationAffiliateModel,
    donationAffiliateItems,
    onDelete,
    getDonationAffiliate,
  } = useDonationAffiliateStore()
  const {setField, field, generateForms, submitDone, formLoading, reset} =
    useDonationAffiliateFormStore()

  const navigate = useNavigate()
  const {currentUser} = useAuth()

  useEffect(() => {
    getDonationAffiliate({page: 0, size: 10, reference: navList[activeNavIndex].reference})
  }, [])

  useEffect(() => {
    getDonationAffiliate({page: 0, size: 10, reference: navList[activeNavIndex].reference})
  }, [activeNavIndex])

  useEffect(() => {
    if (submitDone === true && formLoading === false) {
      getDonationAffiliate({page: 0, size: 10})
      reset()
    }
  }, [submitDone, formLoading])

  const handlePageClick = (e: any) => {
    const selectedPage = e.selected
    getDonationAffiliate({page: selectedPage, size: 10})
  }
  return (
    <>
      <div className='card' style={{marginBottom: 10}}>
        <div className='card-header border-0'>
          <div className='d-flex overflow-auto h-55px'>
            <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap'>
              {navList.map((item, index) => {
                return (
                  <li key={index} className='nav-item'>
                    <a
                      className={`nav-link text-active-primary me-6 ${
                        activeNavIndex === index ? 'active' : 'false'
                      }`}
                      href='#'
                      onClick={(e) => {
                        e.preventDefault()
                        setActiveNavIndex(index)
                      }}
                    >
                      {item.name}
                    </a>
                  </li>
                )
              })}
            </ul>
          </div>
        </div>
      </div>
      <KTCard>
        <div className='card-header border-0 pt-6'>
          <h3 className='card-title align-items-start flex-column'>
            <span className='card-label fw-bold fs-3 mb-1'>History Donation</span>
          </h3>
          <div className='card-toolbar'>
            <a
              type='button'
              className='btn btn-primary'
              href={`${process.env.REACT_APP_API_PROGRAM_URL}/public/export-donations?company_id=${currentUser?.data?.company?.id}&reference=${navList[activeNavIndex].reference}`}
              target='_blank'
              rel='noreferrer'
            >
              <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-2' />
              Export Excel
            </a>
          </div>
        </div>
        <div className='card-body py-3'>
          <div className='table-responsive'>
            {donationAffiliateLoading ? <LoadingComponent /> : <></>}
            <table className='table table-row-bordered table-striped table-hover table-row-gray-100 align-middle gs-3 gy-3'>
              <thead className='text-start text-muted fw-bold fs-7 text-uppercase gs-0'>
                <tr>
                  <th>Donatur</th>
                  <th>Program</th>
                  <th>Amount</th>
                  <th>Channel</th>
                  <th>Profiling</th>
                  <th>Date</th>
                  <th>Status</th>
                  <th>E-Kwitansi</th>
                </tr>
              </thead>
              <tbody className='text-gray-600 fw-semibold'>
                {donationAffiliateItems.length === 0 ? (
                  <tr>
                    <td colSpan={10}>
                      <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                        No Properties Found
                      </div>
                    </td>
                  </tr>
                ) : (
                  donationAffiliateItems?.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td>
                          {item.customer?.values?.find(
                            (el) =>
                              el.name === 'nama-lengkap' ||
                              el.name === 'nama-perusahaan' ||
                              el.name === 'nama-komunitas'
                          )?.value ?? '-'}
                        </td>
                        <td>{item.program?.title}</td>
                        <td>{generateCurrencyFormat(item.amount)}</td>
                        <td>{item?.channel?.channel_name}</td>
                        <td>
                          {item.customer?.values?.find((el) => el.name === 'profiling')?.value ??
                            '-'}
                        </td>
                        <td>{timeDateFormatter(Date.parse(item.created_at.toString()))}</td>
                        <td>{generateStatusBadge(item.status)}</td>

                        <td>
                          <span
                            className='badge badge-success'
                            style={{
                              cursor: 'pointer',
                            }}
                            onClick={(e) => {
                              navigate(
                                `/apps/donation/donation-management/invoice?donation_id=${item.id}`
                              )
                            }}
                          >
                            E-Kwitansi
                          </span>
                        </td>

                        <td className='text-end'>
                          {currentUser?.data?.role?.slug === 'superadmin' ||
                          currentUser?.data?.role?.slug === 'admin' ? (
                            <>
                              <a
                                href={`#`}
                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                onClick={(e) => {
                                  e.preventDefault()
                                  setField(item)
                                  generateForms({
                                    title: 'Update Donation',
                                    subtitle: 'Update Donation',
                                    action: FormAction.UPDATE,
                                    data: item,
                                    id: item.id,
                                  })
                                }}
                              >
                                <KTSVG
                                  path='/media/icons/duotune/art/art005.svg'
                                  className='svg-icon-3'
                                />
                              </a>
                              <a
                                href='#'
                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                                onClick={(e) => {
                                  e.preventDefault()
                                  onDelete(item.id, {
                                    page: 0,
                                    size: 10,
                                  })
                                }}
                              >
                                <KTSVG
                                  path='/media/icons/duotune/general/gen027.svg'
                                  className='svg-icon-3'
                                />
                              </a>
                            </>
                          ) : (
                            <></>
                          )}
                        </td>
                      </tr>
                    )
                  })
                )}
              </tbody>
            </table>
          </div>

          <div className='card-footer'>
            <ReactPaginate
              previousLabel={'«'}
              nextLabel={'»'}
              breakLabel={'...'}
              breakClassName={'page-item'}
              breakLinkClassName={'page-link'}
              previousClassName={'page-item'}
              previousLinkClassName={'page-link'}
              nextClassName={'page-item'}
              nextLinkClassName={'page-link'}
              pageCount={donationAffiliateModel?.data?.total_pages}
              marginPagesDisplayed={2}
              pageRangeDisplayed={10}
              onPageChange={handlePageClick}
              containerClassName={'pagination pagination-sm m-0 float-right'}
              pageClassName={'page-item'}
              pageLinkClassName={'page-link'}
              activeClassName={'active'}
            />
          </div>
        </div>
      </KTCard>
      {field !== undefined && <DonationAffiliateModalComponent />}
    </>
  )
}

export default DonationListAffiliatorComponent
